import React from 'react'

import type { IconProps } from './types'

const ArrowDownTail: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.7727 9.7478C13.9193 9.89405 13.9939 10.0862 13.9939 10.2781C13.9939 10.47 13.9193 10.6617 13.7727 10.8083L9.53048 15.0505C9.23798 15.3438 8.76319 15.3438 8.46994 15.0505L4.22775 10.8083C3.9345 10.5158 3.9345 10.0411 4.22775 9.7478L4.2922 9.68335C4.5847 9.3901 5.0595 9.3901 5.35275 9.68335L8.25021 12.5808L8.25021 2.77808C8.25021 2.36408 8.58621 2.02808 9.00021 2.02808C9.41421 2.02808 9.75021 2.36408 9.75021 2.77808L9.75021 12.5808L12.6477 9.68335C12.9402 9.3901 13.415 9.3901 13.7082 9.68335L13.7727 9.7478Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowDownTail
